import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class BlockSliderTermites {
	static init() {
		this.sliders = document.querySelectorAll(".block-slider-termites");

		if(!this.sliders) {
			return;
		}

		this.reveal();
		this.buildSliders();
	}

	static reveal() {
		// const navs = block.querySelectorAll(".swiper-button");
		this.sliders.forEach(slider => {

			let q = gsap.utils.selector(slider);
			let navs = q(".arrows .svg");
			let slides = q(".swiper-slide");
			gsap.set(navs, { autoAlpha: 0, y: () => window.innerWidth < 768 ? 0 : 60});
			gsap.set(slides, { autoAlpha: 0, x: 70});

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: slider,
					start: "top 95%",
					end: "top 15%",
					scrub: true,
				}
			});

			tl.to(slides, { autoAlpha: 1, x: 0, stagger: 0.3, duration: 1, ease: "power3.out"});
			tl.to(navs, { autoAlpha: 1, y: 0, stagger: 0.3, duration: 1, ease: "power3.out"}, "<+0.5" );
		});
	}

	static buildSliders() {
		this.sliders.forEach(slider => {
			const stage = slider.querySelector(".swiper-slider-scrollable");
			const prev = slider.querySelector(".prev");
			const next = slider.querySelector(".next");
			const swiper = new Swiper(stage, {
				loop: false,
				grabCursor: true,
				slidesPerView: "auto",
				spaceBetween: stage.dataset.spaceBetween ? stage.dataset.spaceBetween : "4%",
				speed: 500,
				touchEventsTarget: "container",
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});


		});
	}
}